/**
 * Type for spacing density
 */
export enum SpacingDensity {
  Compact = 'Compact',
  Comfortable = 'Comfortable',
  Spacious = 'Spacious',
}
